export { SocialTikTok as default } from './SocialTikTok';
